import { render, staticRenderFns } from "./SpeciesEdit.vue?vue&type=template&id=8aaf5764"
import script from "./SpeciesEdit.vue?vue&type=script&lang=js"
export * from "./SpeciesEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports